import type { Category } from "@/lib/types";
import { contrastText, validColor } from "@/lib/color";

interface Props {
  search: string;
  onSearchChange: (value: string) => void;
  cate: string;
  onCateChange: (cate: string) => void;
  categories: Category[];
  geoState: "idle" | "loading" | "error";
  onMyLocation: () => void;
}

export default function BizTopbar({
  search,
  onSearchChange,
  cate,
  onCateChange,
  categories,
  geoState,
  onMyLocation,
}: Props) {
  return (
    <div className="border-b border-background-200 bg-background-50 px-4 py-3 md:px-6">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
        <div className="relative w-full sm:max-w-xs">
          <i
            className="ri-search-line pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400"
            aria-hidden="true"
          ></i>
          <input
            type="search"
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder="사업장명·회원명·주소 검색"
            aria-label="사업장 검색"
            className="w-full rounded-full border border-background-300 bg-background-50 py-2 pl-9 pr-4 text-sm text-foreground-900 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-100"
          />
        </div>

        <button
          type="button"
          onClick={onMyLocation}
          className="inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-full border border-primary-200 bg-primary-50 px-4 py-2 text-sm font-semibold text-primary-700 hover:bg-primary-100 transition-colors sm:ml-auto"
        >
          {geoState === "loading" ? (
            <i className="ri-loader-4-line animate-spin" aria-hidden="true"></i>
          ) : (
            <i className="ri-navigation-fill" aria-hidden="true"></i>
          )}
          내 위치
        </button>
      </div>

      <div className="mt-3 flex gap-2 overflow-x-auto pb-1">
        <button
          type="button"
          onClick={() => onCateChange("")}
          className={`whitespace-nowrap rounded-full border px-3.5 py-1.5 text-sm font-medium transition-colors ${
            cate === ""
              ? "border-primary-500 bg-primary-500 text-background-50"
              : "border-background-300 bg-background-50 text-foreground-700 hover:bg-background-100"
          }`}
        >
          전체
        </button>
        {categories.map((c) => {
          const selected = cate === c.code;
          const color = validColor(c.color) || "#17408B";
          return (
            <button
              key={c.code}
              type="button"
              onClick={() => onCateChange(c.code)}
              style={selected ? { backgroundColor: color, borderColor: color, color: contrastText(color) } : undefined}
              className={`whitespace-nowrap rounded-full border px-3.5 py-1.5 text-sm font-medium transition-colors ${
                selected
                  ? ""
                  : "border-background-300 bg-background-50 text-foreground-700 hover:bg-background-100"
              }`}
            >
              {c.name}
              {typeof c.cnt === "number" && (
                <span className={`ml-1.5 text-xs ${selected ? "opacity-80" : "text-foreground-400"}`}>
                  {c.cnt}
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}